import i18next from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './translate/en/translation.json';

// English ships in the main bundle (it is also the fallback); every other language
// is a separate chunk loaded when a page in that language opens.
// A new language = src/translate/<code>/translation.json + its code in LANGUAGES.
i18next.use(initReactI18next).init({
  resources: {en: {translation: en}},
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {escapeValue: false},
  react: {useSuspense: false},
});

export const loadLanguage = async (lang) => {
  if (i18next.hasResourceBundle(lang, 'translation')) return;
  const {default: translation} = await import(`./translate/${lang}/translation.json`);
  i18next.addResourceBundle(lang, 'translation', translation);
};

export default i18next;
